(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jas-b2b-lead-tracking"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (!/^\/(?:pages\/)?pilates-grosshandel\/?$/.test(location.pathname)) return;
  if (window.jasB2BLeadTracking || !window.fetch) return;
  const state = window.jasB2BLeadTracking = {
    version: '20260909.2', submissionsObserved: 0, formPostsObserved: 0, conversionsQueued: 0, status: 'waiting_for_form'
  };
  const destination = 'AW-16894004727/p4zECMn-hfEcEPeb2Pc-';
  const storageKey = 'jas_b2b_lead_1063752';
  const originalFetch = window.fetch;
  let configured = false;
  let pending = false;
  let queued = false;
  let transactionId = '';
  const previewTheme = window.Shopify && window.Shopify.theme;
  const diagnostic = new URLSearchParams(location.search).get('jas_b2b_check') === '1' ||
    !!(previewTheme && String(previewTheme.id) === '189413097793' && previewTheme.role === 'unpublished');
  function showStatus(value) {
    state.status = value;
    if (!diagnostic || !document.body) return;
    let box = document.getElementById('jas-b2b-tracking-check');
    if (!box) {
      box = document.createElement('div');
      box.id = 'jas-b2b-tracking-check';
      box.setAttribute('role', 'status');
      box.style.cssText = 'position:fixed;top:12px;right:12px;bottom:auto;left:auto;z-index:2147483647;background:#fff;color:#111;border:2px solid #188038;padding:12px;max-width:90vw;font:14px/1.5 sans-serif;box-shadow:0 2px 12px #0003;';
      document.body.appendChild(box);
    }
    box.textContent = 'B2B tracking check v2: ' + value + ' | requests: ' + state.formPostsObserved + ' | success events: ' + state.conversionsQueued;
    document.documentElement.setAttribute('data-jas-b2b-ready', 'true');
  }
  function permitted() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function tag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }
  function configure() {
    if (configured || !permitted()) return;
    const existing = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
    if (!existing) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16894004727';
      document.head.appendChild(script);
      tag('js', new Date());
    }
    tag('config', 'AW-16894004727', { send_page_view: false });
    configured = true;
  }
  function emit() {
    if (!pending || queued) return;
    if (!permitted()) { showStatus('success_waiting_for_consent'); return; }
    configure();
    let prior;
    try { prior = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
    if (prior && prior.id && Date.now() - prior.time < 1800000) {
      queued = true;
      showStatus('duplicate_suppressed');
      return;
    }
    if (!transactionId) transactionId = 'b2b-1063752-' + crypto.randomUUID();
    queued = true;
    try { sessionStorage.setItem(storageKey, JSON.stringify({ id: transactionId, time: Date.now() })); } catch (_) {}
    state.conversionsQueued += 1;
    showStatus('conversion_queued');
    tag('event', 'conversion', {
      send_to: destination, value: 0, currency: 'EUR', transaction_id: transactionId,
      event_callback: function () { showStatus('tag_callback_received'); }
    });
  }
  function matched(input, options) {
    try {
      const rawUrl = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
      const url = new URL(rawUrl, location.href);
      const method = String((options && options.method) || (input && input.method) || 'GET').toUpperCase();
      if (url.origin !== 'https://forms.shopifyapps.com' || !/^\/api\/(?:v2\/)?form_submission\/?$/.test(url.pathname) || method !== 'POST') return false;
      state.formPostsObserved += 1;
      if (!options || typeof options.body !== 'string') { showStatus('unsupported_request_body'); return false; }
      const body = JSON.parse(options.body);
      if (String(body.form_instance_id) !== '1063752') {
        const formId = /^\d+$/.test(String(body.form_instance_id)) ? String(body.form_instance_id) : 'unknown';
        showStatus('different_form_id_' + formId); return false;
      }
      if (body.shopify_domain !== '1b1h6k-wj.myshopify.com') { showStatus('different_shop'); return false; }
      return true;
    } catch (_) { return false; }
  }
  window.fetch = function (input, options) {
    const target = matched(input, options);
    const result = originalFetch.apply(this, arguments);
    if (target) {
      state.submissionsObserved += 1;
      showStatus('awaiting_server');
      result.then(function (response) {
        if (!response.ok || !(response.headers.get('content-type') || '').includes('application/json')) {
          showStatus('submission_rejected'); return;
        }
        return response.clone().json().then(function (data) {
          if (!data || typeof data !== 'object' || Array.isArray(data) || data.error ||
            (data.errors && (typeof data.errors !== 'object' || Object.keys(data.errors).length)) ||
            data.success === false) { showStatus('submission_rejected'); return; }
          pending = true;
          emit();
        });
      }).catch(function () { showStatus('submission_or_tracking_error'); });
    }
    return result;
  };
  document.addEventListener('visitorConsentCollected', function () { configure(); emit(); });
  document.addEventListener('DOMContentLoaded', function () { configure(); showStatus(state.status); });
  configure();
  showStatus(state.status);
})();
  } catch(e) { console.error(e); }
})();

})();
